import { styled } from '../../stitches.config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-regular-svg-icons'
import handleEnterPressEvent from '@/src/common/utilities/handleEnterPressEvent'
import { useGiftQuantityContext } from '@/src/common/contexts/GiftQuantityContext'
import { REMOVE_RECIPIENT } from '@/src/modules/build-a-card/constants'

const DeleteWrapper = styled('div', {
    display: 'flex',
    ai: 'center',
    width: 'max-content',
    cursor: 'pointer',
    gap: 10,
    margin: '10px 0px 30px',
    fontSize: '.95rem',
    textDecoration: 'underline',
    '& p': {
        my: 0,
    },
    '&:focus': {
        outline: '2px solid $primary',
    },
    variants: {
        marginBottom: {
            '15px': {
                marginBottom: 15,
            },
        },
    },
})

type TDeleteRecipientProps = {
    recipientIndex: number
}

const DeleteRecipientButton = ({ recipientIndex }: TDeleteRecipientProps) => {
    const { dispatch, giftState } = useGiftQuantityContext()
    const { listOfRecipients } = giftState
    const isLastItem: boolean = recipientIndex === listOfRecipients?.length - 1

    return (
        <DeleteWrapper
            onClick={() =>
                dispatch({
                    type: REMOVE_RECIPIENT,
                    payload: { recipientIndex: recipientIndex },
                })
            }
            onKeyDownCapture={(e) => {
                handleEnterPressEvent(e, () =>
                    dispatch({
                        type: REMOVE_RECIPIENT,
                        payload: { recipientIndex: recipientIndex },
                    })
                )
            }}
            tabIndex={0}
            marginBottom={isLastItem ? '15px' : undefined}
        >
            <FontAwesomeIcon icon={faTrashCan} />
            <p>Delete this recipient</p>
        </DeleteWrapper>
    )
}

export default DeleteRecipientButton
